import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Modal, Text } from '@rsos/base-components';
import {
  ModalBody,
  ModalHeader,
} from '@rsos/base-components/Modal/ModalComponents';
import type { KeywordSet } from '@rsos/reduxDataStore';
import { KeywordForm } from '../KeywordForm/KeywordForm';

export type KeywordModalProps = {
  save: (keywordSet: KeywordSet) => void;
  keywordSet: KeywordSet;
  title: string;
  id: string;
  children: (opts: { openModal: () => void }) => React.ReactNode;
};

export const KeywordModal = ({
  save,
  keywordSet,
  title,
  id,
  children,
}: KeywordModalProps) => {
  const [params, setParams] = useSearchParams();
  const isOpen = !!params.get(id);
  const close = () => {
    params.delete(id);
    setParams(params);
  };
  const saveAndClose = async (keywordSet: KeywordSet) => {
    await save(keywordSet);
    close();
  };

  return (
    <>
      {children({
        openModal: () => {
          params.set(id, 'open');
          setParams(params);
        },
      })}
      <Modal
        id={id}
        portalPriority={2}
        isOpened={isOpen}
        onClose={close}
        disableBackdropClick
      >
        <ModalHeader onClose={close}>
          <Text size="xlarge" color="primaryText" fontWeight="semibold">
            {title}
          </Text>
        </ModalHeader>
        <ModalBody width={480} noFooter>
          <KeywordForm
            keywordSet={keywordSet}
            save={saveAndClose}
            cancel={close}
          />
        </ModalBody>
      </Modal>
    </>
  );
};
